import { useStaticQuery, graphql } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

const ghostImg = {
  node: {
    childImageSharp: {
      fluid: {
        aspectRatio: 0,
        base64: '',
        sizes: '',
        src: '',
        srcSet: '',
      },
    },
  },
};

const QUERY = graphql`
  query {
    images: allFile(filter: { absolutePath: { regex: "//common/" } }) {
      edges {
        node {
          extension
          relativePath
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 75
              breakpoints: [300, 500, 1024]
              placeholder: BLURRED
              backgroundColor: "transparent"
            )
          }
        }
      }
    }
  }
`;

const UseSiteImages = () => {
  const { images } = useStaticQuery(QUERY);
  return images.edges || [];
};

export const findImage = (imageFileName) => {
  const data = UseSiteImages();
  const img = imageFileName
    ? data.find(
      image => image.node.relativePath.replace(/\.[^/.]+$/, '').toLowerCase()
          === imageFileName.toLowerCase(),
    )
    : null;

  return img ? getImage(img.node) : '';
};

export default findImage;
